export default __webpack_public_path__ + "static/media/switch3x.07ff520e.png";